import actions from '@/store/modules/user/actions';
import getters from '@/store/modules/user/getters';
import mutations from '@/store/modules/user/mutations';

export const state = {
  accessToken: null,
  authCode: '',
  message: '',
  userData: {
    userId: '',
    name: '',
    phone: '',
    userNo: '',
    isPush: '',
    branchName: ''
  },
  device: {
    appVersion: null,
    deviceId: null,
    deviceType: null,
    os: null,
    pushToken: null,
    userNo: null
  },
  student: [],
  // MainPage info
  bannerList: [],
  noticeList: [],
  paymentList: [],
  studyList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
